import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, map, merge } from 'rxjs';
import { ToastService } from './behavior/toast.service';

@Injectable({
    providedIn: 'root'
})
export class OfflineService {
    public isOnline$ = new BehaviorSubject<boolean>(navigator.onLine);

    private currentToast: HTMLIonToastElement | null = null;

    constructor(
        private toastService: ToastService,
    ) {
        this.setupNetworkMonitoring();
    }

    private setupNetworkMonitoring(): void {
        this.checkActualConnection().then(online => {
            this.isOnline$.next(online);
        });

        window.addEventListener('online', () => this.handleStateChange(true));
        window.addEventListener('offline', () => this.handleStateChange(false));
    }

    private async handleStateChange(isOnline: boolean) {
        if (isOnline) {
            const trulyOnline = await this.checkActualConnection();
            if (trulyOnline) {
                this.isOnline$.next(true);
            }
        } else {
            this.isOnline$.next(false);
        }
    }

    private async checkActualConnection(): Promise<boolean> {
        return navigator.onLine;
    }
}
